<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'User Bricks' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'User Bricks' | translate}}</h1>
  </div>
</div>


<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'User Bricks Search' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-6">
          <span class="ui-fluid">
            <p-dropdown [options]="users"
                        name="user" #user="ngModel"
                        styleClass="wid100"
                        placeholder="User"
                        emptyFilterMessage="No results found"
                        showClear="true"
                        (onChange)="getUserBricks()"
                        [(ngModel)]="selectedUser"
                        [virtualScroll]="true" itemSize="10"
                        [filter]="true" optionLabel="fullName"></p-dropdown>
          </span>
        </div>
        <div class="col-sm-2 margin-top-10 cursor-pointer" (click)="getUserBricks()">
          <span class="margin-right-7 filter-span">{{'app.Filter' | translate}}</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>
        <div class="col-sm-2 margin-top-10 left-8 cursor-pointer" (click)="addUserBricks()" *ngIf="canAddUserBricksPermission">
          <span class="margin-right-7 create-new-span">Add Bricks</span>
          <i class="fa fa-file-text"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<crm-add-user-bricks *ngIf="showAddBricks" [userId]="selectedUser.id" (closeEvent)="closeListing($event)"></crm-add-user-bricks>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'User Bricks Result' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">
          <p-table #dt [value]="bricks" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
            <ng-template pTemplate="header">
              <tr>
                <th [pSortableColumn]="brickName" width="30%" style="text-align:center" class="table-edit">
                 Brick Name
                  <p-sortIcon [field]="brickName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th width="10%" style="text-align:center" class="table-edit"  *ngIf="canDeleteUserBricksPermission">{{'app.delete' | translate}}</th>

            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr *ngIf="bricks.length>0 && displayMode==2">
                <td> {{ item.brickName}}</td>
                <td  *ngIf="canDeleteUserBricksPermission">
                  <a class="" href="javascript:;" (click)="confirmDelete(item)">
                    <i class="fa fa-trash-o fa-lg font-size-20"></i>
                  </a>
                </td>
              </tr>
              <tr *ngIf="bricks.length==0 && displayMode==2">
                <td colspan="5">{{'app.NoDataFound' | translate}}</td>
              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="5">
                  <div class="row col-sm-12 padding-sm-hr">
                    <div class="container text-center">
                      <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="displayMode==3">
                <td colspan="5">
                  <div class="alert alert-danger alert-dark">
                    <button type="button" class="close" data-dismiss="alert">×</button>
                    {{'app.ServerError' |translate}}.
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="modal fade" bsModal #deleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="delete-title">{{'app.deleteMsgConfirmation' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideDeleteModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="delete()">{{'app.delete' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
